import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * Renders children only for users with TL role. Others are redirected to dashboard.
 */
const TLOnlyRoute = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  const isTL = user?.role?.name === 'TL';

  if (!isTL) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default TLOnlyRoute;
